import Vue from "vue";
import Router from "vue-router";
import Login from "@/pages/login";
import Main from "@/pages/main";
import ListUsers from "@/pages/dataMgr/listUsers";
import ListEducations from "@/pages/dataMgr/listEducations";
import ListJobs from "@/pages/dataMgr/listJobs";
import ListJournals from "@/pages/dataMgr/listJournals";
import ListHonors from "@/pages/dataMgr/listHonors";
import EditInfo from "@/pages/dataMgr/editInfo";
import EditInfo1 from "@/pages/dataMgr/editInfo1";
import UserDetails from "@/pages/dataMgr/userDetails";
import JournalDetails from "@/pages/dataMgr/journalDetails";
import JournalDetailsManual from "@/pages/dataMgr/journalDetailsManual";
import JournalDetailsManualAdd from "@/pages/dataMgr/journalDetailsManualAdd";
import OpLog from "@/pages/dataMgr/opLog";
import ApplyLog from "@/pages/dataMgr/applyLog";
import ScanWord from "@/pages/dataMgr/scanWord";
import DataStatis from "@/pages/dataMgr/statisticalData";
import AdminSetting from "@/pages/dataMgr/adminSetting";

import Banners from "@/pages/wxapp/banners";
import BannerAdd from "@/pages/wxapp/bannerAdd";
import Activity from "@/pages/wxapp/activity";
import ActivityAdd from "@/pages/wxapp/activityAdd";
import NewsList from "@/pages/wxapp/newsList";
import newsAdd from "@/pages/wxapp/newsAdd";
import MemorabiliaList from "@/pages/wxapp/memorabiliaList";
import MemorabiliaAdd from "@/pages/wxapp/memorabiliaAdd";
import AssociationList from "@/pages/wxapp/associationList";
import Association from "@/pages/wxapp/association";
import AssociationAdd from "@/pages/wxapp/associationAdd";
import AssociationNewsAdd from "@/pages/wxapp/associationNewsAdd";
import AssociationActivitysAdd from "@/pages/wxapp/associationActivitysAdd";
import Authentication from "@/pages/wxapp/authentication";
import AuthenticationDataDetails from "@/pages/wxapp/authenticationDataDetails";
import AuthenticationRegisterDetails from "@/pages/wxapp/authenticationRegisterDetails";
import AuthenticationFaceDetails from "@/pages/wxapp/authenticationFaceDetails";
import AuthActivationDetails from "@/pages/wxapp/authActivationDetails";
import Enterprise from "@/pages/wxapp/enterprise";
import EnterpriseAdd from "@/pages/wxapp/enterpriseAdd";
import EnterpriseClassifyAdd from "@/pages/wxapp/enterpriseClassifyAdd";
import EnterpriseDetail from "@/pages/wxapp/enterpriseDetail";
import EnterpriseReview from "@/pages/wxapp/enterpriseReview";
import Welfare from "@/pages/wxapp/welfare";
import WelfareAdd from "@/pages/wxapp/welfareAdd";
import WelfareRecruitAdd from "@/pages/wxapp/welfareRecruitAdd";
import DonationList from "@/pages/wxapp/donationList";
import DonationAdd from "@/pages/wxapp/donationAdd";
import Integral from "@/pages/wxapp/integral";
import IntegralProductAdd from "@/pages/wxapp/integralProductAdd";
import IntegralOrderDetails from "@/pages/wxapp/integralOrderDetails";
import PhotoExamine from "@/pages/wxapp/photoExamine";
import AgreemenManager from "@/pages/wxapp/agreemenManager";
import surveyManager from "@/pages/wxapp/surveyManager";
import survey from "@/pages/wxapp/survey";
import Statistic from "@/pages/wxapp/statistic";
import Wishes from "@/pages/wxapp/wishes";
import Video from "@/pages/wxapp/video";
import WishesAdd from "@/pages/wxapp/wishesAdd";

Vue.use(Router);

const router = new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'Index',
    //   component: Index
    // },
    {
      path: "/",
      component: Login
    },
    {
      path: "/main",
      component: Main
    },
    {
      path: "/data/users",
      component: ListUsers,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/data/educations",
      component: ListEducations,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/data/jobs",
      component: ListJobs,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/data/journals",
      component: ListJournals,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/data/honors",
      component: ListHonors,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/data/edit",
      component: EditInfo
    },
    {
      path: "/data/user-edit",
      component: EditInfo1
    },
    {
      path: "/data/user-details",
      component: UserDetails
    },
    {
      path: "/data/journal-details",
      component: JournalDetails
    },
    {
      path: "/data/journal-details-manual",
      component: JournalDetailsManual
    },
    {
      path: "/data/journal-details-manual-add",
      component: JournalDetailsManualAdd
    },
    {
      path: "/data/op-log",
      component: OpLog,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/data/apply-log",
      component: ApplyLog,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/data/scan-word",
      component: ScanWord,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/data/statisticalData",
      component: DataStatis
    },
    {
      path: "/data/admin-setting",
      component: AdminSetting,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/banners",
      component: Banners,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/banner_add",
      component: BannerAdd
    },
    {
      path: "/wxapp/activity",
      component: Activity,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/activity_add",
      component: ActivityAdd
    },
    {
      path: "/wxapp/newsList",
      component: NewsList,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/news_add",
      component: newsAdd
    },
    {
      path: "/wxapp/memorabiliaList",
      component: MemorabiliaList,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/memorabilia_add",
      component: MemorabiliaAdd
    },
    {
      path: "/wxapp/associationList",
      component: AssociationList,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/association",
      component: Association
    },
    {
      path: "/wxapp/association_add",
      component: AssociationAdd
    },
    {
      path: "/wxapp/association_news_add",
      component: AssociationNewsAdd
    },
    {
      path: "/wxapp/association_activitys_add",
      component: AssociationActivitysAdd
    },
    {
      path: "/wxapp/authentication",
      component: Authentication,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/authentication_data_details",
      component: AuthenticationDataDetails
    },
    {
      path: "/wxapp/authentication_register_details",
      component: AuthenticationRegisterDetails
    },
    {
      path: "/wxapp/authentication_face_details",
      component: AuthenticationFaceDetails
    },
    {
      path: "/wxapp/auth_activation_details",
      component: AuthActivationDetails
    },
    {
      path: "/wxapp/enterprise",
      component: Enterprise,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/enterprise_add",
      component: EnterpriseAdd
    },
    {
      path: "/wxapp/enterprise_classify_add",
      component: EnterpriseClassifyAdd
    },
    {
      path: "/wxapp/enterprise_detail",
      component: EnterpriseDetail
    },
    {
      path: "/wxapp/enterprise_review",
      component: EnterpriseReview
    },
    {
      path: "/wxapp/welfare",
      component: Welfare,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/welfare_add",
      component: WelfareAdd
    },
    {
      path: "/wxapp/welfare_recruit_add",
      component: WelfareRecruitAdd
    },
    {
      path: "/wxapp/donation_list",
      component: DonationList,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/donation_add",
      component: DonationAdd
    },
    {
      path: "/wxapp/integral",
      component: Integral,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/integral_product_add",
      component: IntegralProductAdd
    },
    ,
    {
      path: "/wxapp/integral_order_details",
      component: IntegralOrderDetails
    },
    ,
    {
      path: "/wxapp/photoExamine",
      component: PhotoExamine,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/agreemenManager",
      component: AgreemenManager,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/surveyManager",
      component: surveyManager
    },
    {
      path: "/wxapp/survey",
      component: survey
    },
    {
      path: "/wxapp/statistic",
      component: Statistic,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/wishes",
      component: Wishes,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxapp/wishes_add",
      component: WishesAdd
    },
    {
      path: "/wxapp/video",
      component: Video,
      meta: {
        keepAlive: true
      }
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js